import { ApiMananger } from "./apiMananger";

const homeworkHelpApi = ApiMananger.injectEndpoints({
    endpoints: (build) => ({
        generateQuiz: build.mutation({
            query: ({ images, studentId }) => {
                console.log('🔍 [QUIZ] Données reçues:', { 
                    hasImages: !!images, 
                    studentId: studentId,
                    studentIdType: typeof studentId 
                });
                
                const formData = new FormData();
                
                // Si c'est un tableau, ajouter toutes les images sous la même clé 'image'
                if (Array.isArray(images)) {
                    images.forEach((image) => {
                        formData.append('image', image); // Même clé 'image' pour tous les fichiers
                    });
                } else {
                    // Sinon, ajouter une seule image
                    formData.append('image', images);
                }
                
                // Ajouter le student_id si fourni
                if (studentId) {
                    formData.append('student_id', studentId);
                    console.log('✅ [QUIZ] student_id ajouté au FormData:', studentId);
                } else {
                    console.warn('⚠️ [QUIZ] student_id est undefined/null!');
                }
                
                // Log du contenu du FormData
                console.log('📦 [QUIZ] FormData entries:');
                for (let pair of formData.entries()) {
                    console.log(`  - ${pair[0]}:`, pair[1]);
                }
                
                return {
                    url: "image_quizz/",
                    method: "POST",
                    body: formData,
                    formData: true,
                };
            },
        }),
        submitQuizAnswers: build.mutation({
            query: ({ quizSessionId, answers }) => ({
                url: `quiz-sessions/${quizSessionId}/submit/`,
                method: "POST",
                body: { answers },
            }),
        }),
        resolveExercise: build.mutation({
            query: ({ image, studentId }) => {
                console.log('🔍 [RESOLUTION] Données reçues:', { 
                    hasImage: !!image, 
                    studentId: studentId,
                    studentIdType: typeof studentId 
                });
                
                const formData = new FormData();
                
                // Pour la résolution, on n'accepte qu'une seule image
                formData.append('image', image);
                
                // Ajouter le student_id si fourni
                if (studentId) {
                    formData.append('student_id', studentId);
                    console.log('✅ [RESOLUTION] student_id ajouté au FormData:', studentId);
                } else {
                    console.warn('⚠️ [RESOLUTION] student_id est undefined/null!');
                }
                
                // Log du contenu du FormData
                console.log('📦 [RESOLUTION] FormData entries:');
                for (let pair of formData.entries()) {
                    console.log(`  - ${pair[0]}:`, pair[1]);
                }
                
                return {
                    url: "image_resolution/",
                    method: "POST",
                    body: formData,
                    formData: true,
                };
            },
        }),
    }),
});

export const {
    useGenerateQuizMutation,
    useSubmitQuizAnswersMutation,
    useResolveExerciseMutation,
} = homeworkHelpApi; 